import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAGm1QV6F4N2qWT5nI4A2JV24C3wIGFgcg",
  authDomain: "the-storyline-studio.firebaseapp.com",
  projectId: "the-storyline-studio",
  storageBucket: "the-storyline-studio.firebasestorage.app",
  messagingSenderId: "939961838314",
  appId: "1:939961838314:web:ab9ca3832c684ac1f24593"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore
const db = getFirestore(app);

// Storage
const storage = getStorage(app);

// Authentication
const auth = getAuth(app);

// Export everything
export { db, storage, auth };